import { useEffect, useCallback } from 'react';

interface UseKeyboardShortcutsProps {
  onQuickLinksOpen: () => void;
}

export function useKeyboardShortcuts({ onQuickLinksOpen }: UseKeyboardShortcutsProps) {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      // Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
      if (event.key === 'k' && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        onQuickLinksOpen();
      }
    },
    [onQuickLinksOpen],
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
}
